import React from 'react';
import { cn } from '../../lib/utils';

export default function PageHeader({
  title,
  subtitle,
  icon: Icon,
  actions,
  className,
  variant = 'default'
}) {
  return (
    <div className={cn(
      "flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8",
      variant === 'large' && "pb-6 border-b border-border/50",
      className
    )}>
      <div className="space-y-1.5">
        <div className="flex items-center gap-3">
          {Icon && (
            <div className={cn(
              "shrink-0 w-10 h-10 rounded-xl flex items-center justify-center",
              "bg-primary/10 text-primary border border-primary/20"
            )}>
              <Icon className="w-5 h-5" />
            </div>
          )}
          <h1 className={cn(
            "text-2xl md:text-3xl font-black tracking-tight text-foreground",
            variant === 'large' && "text-3xl md:text-4xl"
          )}>
            {title}
          </h1>
        </div>
        {subtitle && (
          <p className="text-sm text-muted-foreground max-w-2xl leading-relaxed ml-13">
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-3 shrink-0">
          {actions}
        </div>
      )}
    </div>
  );
}
